import { enFrancaisAvecAnnee } from '../datesEnMots';

/*
 * La Liste refaite d'après sa maquette (chantier `revue-design`, ticket 03, `design/liste.html`,
 * décisions d'Igor du 2026-10-03, « La Liste » 1 à 3).
 */
export const RANGER = 'Ranger';
export type Rangement = 'mon_ordre' | 'importance' | 'date';
/** Les trois choix de « Ranger », dans l'ordre de la maquette ; « Dans mon ordre » par défaut. */
export const RANGEMENTS: [Rangement, string][] = [
  ['mon_ordre', 'Dans mon ordre'],
  ['importance', 'Par importance'],
  ['date', 'Par date'],
];
export const DEPLIER_SES_TACHES = 'Déplier ses tâches';
export const REPLIER_SES_TACHES = 'Replier ses tâches';
/** Les gestes d'une ligne de la Liste (décision 2) : un clic ouvre la fiche, un double-clic entre. */
export const GESTES_DE_LA_LISTE = 'Clic : sa fiche · double-clic : entrer dedans';
/**
 * Au téléphone, un seul geste (chantier `telephone-cadre`, ticket 04, `ligneAuPouce.ts`) : une
 * tâche s'ouvre, on entre dans une étape ; l'appui long ouvre la fiche des deux.
 */
export const GESTES_D_UNE_TACHE_AU_POUCE = 'Toucher : sa fiche';
export const GESTES_D_UNE_ETAPE_AU_POUCE = 'Toucher : entrer dedans · appui long : sa fiche';

/**
 * Ce qu'une ligne de la Liste dit d'elle-même, à droite (décision 3, maquette `liste.html`) :
 * des morceaux qui suivent le titre, en minuscules comme la maquette (« 1 sur 3 · attend une
 * réponse », « 1 h · il faut y aller », « fait », « idée gardée en réflexion »).
 */
export const LIGNE_FAITE = 'fait';
export const LIGNE_IDEE = 'idée gardée en réflexion';
export const LIGNE_ATTEND = 'attend une réponse';
export function reponseAttendueIlYA(jours: number): string {
  return jours === 1 ? 'réponse attendue hier' : `réponse attendue il y a ${jours} jours`;
}
export function avantLe(jour: string): string {
  return `avant le ${enFrancaisAvecAnnee(jour)}`;
}
/** Sous le champ du bas de la feuille, une bulle écrite sans réseau, en file. */
export const ECRIT_HORS_LIGNE = 'Écrit hors ligne — repartira tout seul';
